// extracted by mini-css-extract-plugin
export default {"content":"aIpWV","doubleCol":"ZpNGC"};